import { createAction, props } from '@ngrx/store';
import { IMarketingResponse } from '../models/marketing-options.model';

export const loadGetMarketingOptions = createAction('[GetMarketingOptions] Load Get GetMarketingOptions');

export const loadGetMarketingOptionsSuccess = createAction(
  '[GetMarketingOptions] Load Get GetMarketingOptions Success',
  props<{ response: IMarketingResponse }>()
);

export const loadGetMarketingOptionsFailure = createAction(
  '[GetMarketingOptions] Load Get GetMarketingOptions Failure',
  props<{ error: Error | any }>()
);
